// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1tM8m","subheader":"ReorderModal_subheader__1WXFt","listWrap":"ReorderModal_listWrap__3idl-"};